var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    transform: "translate(-31 -207)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(31 207)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106",
    transform: "translate(545.787 113.821)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3531",
    "data-name": "Path 3531",
    d: "M-500.966,133.728c0,.45-.009.9,0,1.349a.663.663,0,0,1-.24.547A6.929,6.929,0,0,0-502.915,138a6.617,6.617,0,0,0,1.465,7.395,6.677,6.677,0,0,0,5.388,1.893,6.632,6.632,0,0,0,5.763-5.036,6.515,6.515,0,0,0-2.135-6.652.562.562,0,0,1-.167-.367c-.013-.977-.01-1.955-.006-2.933a.412.412,0,0,1,.666-.383,9.812,9.812,0,0,1,4.541,5.27,10,10,0,0,1-7.278,13.229,9.954,9.954,0,0,1-11.688-6.962,9.674,9.674,0,0,1,3.007-10.312,16.307,16.307,0,0,1,1.68-1.2.445.445,0,0,1,.72.42C-500.989,132.814-500.966,133.272-500.966,133.728Z",
    transform: "translate(0 -29.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3532",
    "data-name": "Path 3532",
    d: "M-293.582,106.164q0-2.21,0-4.419c0-.449.118-.566.569-.566h2.268c.358,0,.5.137.5.493q0,4.507,0,9.014c0,.366-.145.5-.515.5h-2.288c-.391,0-.538-.148-.538-.546Q-293.583,108.4-293.582,106.164Z",
    transform: "translate(-204.877)",
    fill: "#ffe500"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/LogoutIcon.ce4ef588094ddcf12f720a887b9c616d.svg";
export { ForwardRef as ReactComponent };